import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'prlw-dynamic-input-placeholder-wrapper',
  templateUrl: './dynamic-input-placeholder.component.html',
  styleUrls: ['./dynamic-input-placeholder.component.scss'],
  //TODO: need to fix it and make it work witch "OnPush"
  // eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
  changeDetection: ChangeDetectionStrategy.Default,
})
export class DynamicInputPlaceholderComponent {
  @Input() public text: string = '';
  @Input() public margin: number = 0;
  @Input() public isVisible: boolean = false;
}
